import { render, staticRenderFns } from "./LocalSearch.vue?vue&type=template&id=35bd7f95"
import script from "./LocalSearch.vue?vue&type=script&lang=js"
export * from "./LocalSearch.vue?vue&type=script&lang=js"
import style0 from "./LocalSearch.vue?vue&type=style&index=0&id=35bd7f95&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports